import script from "./SubscribedTargetCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./SubscribedTargetCard.vue?vue&type=script&setup=true&lang=ts"

import "./SubscribedTargetCard.vue?vue&type=style&index=0&id=3215c07e&lang=stylus"

export default script